import React, { PropTypes } from "react";
import styled from "styled-components";

import {
  NitroHeading,
  NitroIcon,
  NitroPanel,
  NitroText
} from "nitro-components";

const Card = styled.div`
  text-align: center;
  opacity:0.88;
  transition: all .2s ease-in-out;
  backface-visibility: hidden;

&:hover{
  opacity:1;
  transform: scale(1.018);
  cursor:pointer;

}
`;

const CardContent = styled.div`
height:135px;
`;

const CardHeading = styled.header`
  margin: 10px 0;
`;

const CardSuggestion = ({ description, icon, title }) => {
  return (
    <Card>
      <NitroPanel>
        <CardContent>
          <NitroIcon name={icon} size={30} variant="secondary" />
          <CardHeading>
            <NitroHeading
              align="center"
              label={title}
              noMargin
              size={2}
              variant="secondary"
            />
          </CardHeading>
          <NitroText variant="base3">
            {description}
          </NitroText>
        </CardContent>
      </NitroPanel>
    </Card>
  );
};

CardSuggestion.propTypes = {
  description: PropTypes.string,
  title: PropTypes.string,
  icon: PropTypes.string
};

export default CardSuggestion;



// WEBPACK FOOTER //
// ./src/features/dashboard/components/ProfileTabs/CardSuggestion.js